import { put, takeLatest, call } from "redux-saga/effects";
import {
	setListRole,
	setDetailRole,
	deleteRole,
	GetListRoleAsyncPayload,
	getListRoleAsync,
	GetDetailRoleAsyncPayload,
	getDetailRoleAsync,
	CreateRoleAsyncPayload,
	createRoleAsync,
	UpdateRoleAsyncPayload,
	updateRoleAsync,
	DeleteRoleAsyncPayload,
	deleteRoleAsync,
	UpdateRolePermissionAsyncPayload,
	updateRolePermissionAsync,
} from "./role.slice";
import { message } from "antd";
import { setLoadingPage } from "store/app/app.slice";
import api from "service/apiService";
import { t } from "@lingui/macro";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiResponse } from "types";
import { Role } from "../types";

// Get list
function* getListRoleSaga(action: PayloadAction<GetListRoleAsyncPayload>) {
	const { response, error } = yield call(async () => {
		const { query } = action.payload;
		let { skip } = query;
		const { take } = query;
		skip = skip * take;
		try {
			const { data: response } = await api.get<ApiResponse<Role[]>>("/role", {
				...query,
				skip,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListRole.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetListRole() {
	yield takeLatest(getListRoleAsync, getListRoleSaga);
}

// Delete
function* deleteRoleSaga(action: PayloadAction<DeleteRoleAsyncPayload>) {
	const { id } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const response = await api.delete("/role/" + id);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(t`Delete successful`);
		yield put({ type: deleteRole.type, payload: { id } });
	} else {
		message.error(error.message);
	}
}
function* watchDeleteRole() {
	yield takeLatest(deleteRoleAsync, deleteRoleSaga);
}

// Detail
function* getDetailRoleSaga(action: PayloadAction<GetDetailRoleAsyncPayload>) {
	const { id } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Role>>(
				`/role/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setDetailRole.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetDetailRole() {
	yield takeLatest(getDetailRoleAsync, getDetailRoleSaga);
}

// Create
function* createRoleSaga(action: PayloadAction<CreateRoleAsyncPayload>) {
	const { bodyParams, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post("/role", bodyParams);

			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(t`Create successful`);
	} else {
		message.error(error.message);
	}

	callback && callback();
}
function* watchCreateRole() {
	yield takeLatest(createRoleAsync, createRoleSaga);
}

// Update
function* updateRoleSaga(action: PayloadAction<UpdateRoleAsyncPayload>) {
	const { id, data, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const response = await api.put(`/role/${id}`, data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(t`Update successful`);
	} else {
		message.error(translate(error.message));
	}

	callback && callback();
}
function* watchUpdateRole() {
	yield takeLatest(updateRoleAsync, updateRoleSaga);
}

// Update role - permissions
function* updateRolePermissionSaga(
	action: PayloadAction<UpdateRolePermissionAsyncPayload>,
) {
	yield put({ type: setLoadingPage.type, payload: true });
	const { bodyParams } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post("/role/update-multiple", bodyParams);

			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(t`Update successful`);
	} else {
		message.error(error.message);
	}
	yield put({ type: setLoadingPage.type, payload: false });
}
function* watchUpdateRolePermission() {
	yield takeLatest(updateRolePermissionAsync, updateRolePermissionSaga);
}

const customerSaga = [
	watchGetListRole(),
	watchGetDetailRole(),
	watchDeleteRole(),
	watchCreateRole(),
	watchUpdateRole(),
	watchUpdateRolePermission(),
];
export default customerSaga;
